// extracted by mini-css-extract-plugin
export default {"card":"ConceptGroupCard_card__uzRkE","header":"ConceptGroupCard_header__W-T6i"};